import { useMemo } from "react";

import { TiVoTargetsTable, Link } from "components/elements";
import { useTiVoDeviceData } from "components/form/fields/TiVoTargets";
import { GrabsonIcon } from "components/layout";
import { PopupOnClick } from "components/popups";
import { TiVoTargets } from "hooks/tivoApps";

import styles from "./TiVoTargetsSummary.scss";
import { getSummary } from "./utils";

export type TiVoTargetsSummaryProps = {
  targets?: TiVoTargets;
  to?: string;
};

export function TiVoTargetsSummary({ targets, to }: TiVoTargetsSummaryProps) {
  const { getDeviceLabel } = useTiVoDeviceData();

  const summary = useMemo(
    () => getSummary(targets, getDeviceLabel),
    [targets, getDeviceLabel]
  );

  const renderPopup = () => <TiVoTargetsTable targets={targets || {}} />;

  const renderTrigger = () => (
    <GrabsonIcon
      className={styles.popupTrigger}
      name="help-filled"
      size="normal"
    />
  );

  return (
    <div>
      {to ? (
        <Link to={to}>
          <span>{summary}</span>
        </Link>
      ) : (
        <span>{summary}</span>
      )}
      {targets && (
        <PopupOnClick
          alignment="bottom-start"
          className={styles.popup}
          renderPopup={renderPopup}
          renderTrigger={renderTrigger}
        />
      )}
    </div>
  );
}
